module.exports = __webpack_public_path__ + "img/no-reward_orange.2499ef59.svg";